import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { LoginIndex } from "components/pages/login";
import { AuthProvider } from "lib/auth";
import { AppUserStateListener } from "lib/auth/components/AppUserStateLisener";
import { AssetsPreload, ErrorHandler } from "lib/errorHandler";
import { initializeExhClient } from "lib/extrahorizon";
import { PreviousLocation } from "lib/previousLocation";
import { store } from "lib/store";
import ThemeProvider from "lib/themeProvider";

import App from "./components/app";
import { HospitalConfigurationProvider } from "./components/pages/settings/context";

// Initialize ExtraHorizon SDK client on app startup
const exhClientId = process.env.REACT_APP_EXTRAHORIZON_CLIENT_ID;
if (!exhClientId) {
  // eslint-disable-next-line no-console
  console.warn("ExtraHorizon client ID not configured. Check REACT_APP_EXTRAHORIZON_CLIENT_ID environment variable.");
} else {
  try {
    initializeExhClient(exhClientId);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to initialize ExtraHorizon client:", error);
  }
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AssetsPreload />
      <div className="App">
        <Router basename={process.env.PUBLIC_URL}>
          <Provider store={store}>
            <AppUserStateListener />
            <ErrorHandler>
              <PreviousLocation>
                <Routes>
                  <Route path="login/*" element={<LoginIndex />} />
                  <Route
                    path="/*"
                    element={
                      <AuthProvider>
                        <HospitalConfigurationProvider>
                          <App />
                        </HospitalConfigurationProvider>
                      </AuthProvider>
                    }
                  />
                </Routes>
              </PreviousLocation>
            </ErrorHandler>
          </Provider>
        </Router>
      </div>
    </ThemeProvider>
  </React.StrictMode>
);
export { careGiverErrorFieldConverter } from "./lib/biot/careGiver/converters";
